export default "__VITE_PUBLIC_ASSET__1d656f7e__"